export default __webpack_public_path__ + "assets/images/0317c88d792fd00195ca512cd2817dc6.svg";